/**
 * UNE SOIRÉE, UNE PLACE SUR LA PAGE.
 *
 * La page Soirées met certaines nuits en avant : la soirée en cours, les
 * prochaines, et la rétrospective de la semaine. Les répéter trois écrans plus
 * bas dans l'Historique n'apprend rien à personne — c'est la même carte, deux
 * fois, à quelques centimètres d'intervalle.
 *
 * CE QUI N'EST PAS TOUCHÉ : l'historique métier, l'endpoint qui le sert, les
 * exports, la recherche globale. C'est une exclusion de PROJECTION, valable
 * pour CETTE page et cet instant. Dès qu'une soirée n'est plus mise en avant,
 * elle réapparaît d'elle-même dans la liste.
 *
 * L'EXCEPTION QUI COMPTE : chercher est un acte explicite. Une recherche
 * inspecte tout l'historique, y compris ce qui est affiché plus haut — ne pas
 * trouver une soirée parce qu'elle est visible ailleurs serait le contraire
 * d'un moteur de recherche.
 */

export interface SoireeLite {
  id: string; name: string; groupe?: { noms: readonly string[] } | null
  /** Les événements rattachés à la soirée (19/10/2026) : chercher « medecine » trouve L'ÉTUDIANTE du 15/10. */
  rattachees?: ReadonlyArray<{ name: string }> | undefined
}

/** Identifiants déjà représentés dans les sections hautes de la page. */
export function promotedEventIds(o: {
  current?: { id: string } | null
  outlook?: { soiree: { id: string } }[] | null
  retrospective?: { events: { id: string }[] } | null
}): Set<string> {
  const ids = new Set<string>()
  if (o.current) ids.add(o.current.id)
  for (const e of o.outlook ?? []) ids.add(e.soiree.id)
  for (const e of o.retrospective?.events ?? []) ids.add(e.id)
  return ids
}

/**
 * La liste Historique telle qu'elle doit s'afficher SUR CETTE PAGE.
 * `query` vide → on retire ce qui est déjà mis en avant.
 * `query` renseignée → on cherche dans tout, sans rien cacher.
 */
export function projectHistory<T extends SoireeLite>(
  history: T[], promoted: ReadonlySet<string>, query: string,
): T[] {
  const q = query.trim().toLowerCase()
  // Une ligne « INTERSANTE (×8) » regroupe huit événements : chercher
  // « podologie » doit la trouver par le nom de l'événement qu'elle contient.
  if (q !== '') {
    return history.filter((s) => s.name.toLowerCase().includes(q)
      || (s.groupe?.noms ?? []).some((n) => n.toLowerCase().includes(q))
      || (s.rattachees ?? []).some((r) => r.name.toLowerCase().includes(q)))
  }
  return history.filter((s) => !promoted.has(s.id))
}
